export const GET_SUB_DISTRICT_BEGIN = "GET_SUB_DISTRICT_BEGIN"
export const GET_SUB_DISTRICT_SUCCESS = "GET_SUB_DISTRICT_SUCCESS"
export const CLEAR_SUB_DISTRICT = "clear_sub_district"